import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ex-notification-confirm-action',
  templateUrl: './ex-notification-confirm-action.component.html',
  styleUrls: ['./ex-notification-confirm-action.component.css']
})
export class ExNotificationConfirmActionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/auth/signin/ex-notification-confirm-action/ex-notification-confirm-action.component.ts